function Tv() {
  return <h1>Tv</h1>;
}

export default Tv;
